import { Navigate } from "react-router-dom";
import { useUserRole } from "@/hooks/useUserRole";

interface AdminRouteProps {
  children: React.ReactNode;
  /** Restrict to admins only (moderators denied) */
  adminOnly?: boolean;
}

const AdminRoute = ({ children, adminOnly = false }: AdminRouteProps) => {
  const { isAdmin, role, isLoading } = useUserRole();

  const isModerator = role === 'moderator';
  const hasAccess = isAdmin || (!adminOnly && isModerator);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
